import React from "react";
import { isMobile } from "react-device-detect";

import SwipeToConfirm from "../swipe-to-confirm/SwipeToConfirm";
import PressToConfirm from "../press-to-confirm/PressToConfirm";

interface ApprovalControlProps {
  /** 承認確定で一度だけ発火 */
  onConfirm: () => void;
  /**
   * 「OK 状態」の変化を双方向で親に通知する。
   * 承認確定で true、ユーザーが取り消したとき false が渡る。
   */
  onConfirmedChange?: (confirmed: boolean) => void;
  /**
   * 操作ロック（送信中など）。操作は受け付けないが、承認確定済みの
   * 見た目と状態は保持する（送信中に OFF へ戻らない）。
   * 未確定のままロックされた場合のみ初期状態に戻る。
   */
  disabled?: boolean;
  /** カラー指定。既定はテーマブルー。 */
  accentColor?: string;
  /** モバイル時のラベル。既定は「右にスワイプで承認」。 */
  swipeLabel?: string;
  /** デスクトップ時のラベル。既定は「長押しで承認」。 */
  pressLabel?: string;
  /** 確定後のラベル（micro-interaction で表示）。既定は「ありがとう！」。 */
  confirmedLabel?: string;
}

/**
 * デバイス幅に応じてスワイプ（モバイル）／長押し（デスクトップ）の
 * 承認 UI を出し分けるラッパコンポーネント。両者は API 互換なので、
 * 親は同じ props で扱える。
 */
const ApprovalControl: React.FC<ApprovalControlProps> = ({
  onConfirm,
  onConfirmedChange,
  disabled,
  accentColor,
  swipeLabel = "右にスワイプで承認",
  pressLabel = "長押しで承認",
  confirmedLabel = "OK",
}) => {
  if (isMobile) {
    return (
      <SwipeToConfirm
        label={swipeLabel}
        confirmedLabel={confirmedLabel}
        onConfirm={onConfirm}
        onConfirmedChange={onConfirmedChange}
        disabled={disabled}
        accentColor={accentColor}
      />
    );
  }
  return (
    <PressToConfirm
      label={pressLabel}
      confirmedLabel={confirmedLabel}
      onConfirm={onConfirm}
      onConfirmedChange={onConfirmedChange}
      disabled={disabled}
      accentColor={accentColor}
    />
  );
};

export default ApprovalControl;
